
import New2 from '../Altara/Radi (1).webp'
import New3 from '../Altara/Radi (2).webp'
import New4 from '../Altara/Radi (3).webp'
import New5 from '../Altara/Radi (4).webp'
import New6 from '../Altara/Radi (5).webp'
import New7 from '../Altara/Radi (6).webp'
import New8 from '../Altara/Radi (7).webp'
import New9 from '../Altara/Radi (8).webp'
import New10 from '../Altara/Radi (9).webp'
import New11 from '../Altara/Radi (10).webp'


const Newimages =[
    New2,New3,New4,New5,New6,New7,New8,New9,New10,New11
]

export default Newimages;